export const VALIDATORS = {
  REQUIRED: "required",
  REGEX: "regex",
  MIN_LENGTH: "minLength",
  MAX_LENGTH: "maxLength",
  MIN: "min",
  MAX: "max",
  EMAIL: "email",
  PHONE: "phone",
  DATE_MIN: "dateMin",
  DATE_MAX: "dateMax",
  MIN_AGE: "minAge",
  MAX_AGE: "maxAge",
  NIR: "nir",
  IBAN: "iban",
  BIC: "bic",
  CITY_NAME: "cityName",
  CONTRACT_NUMBER: "contractNumber",
};

export const VALIDATION_MESSAGE_KEYS = {
  REQUIRED: "REQUIRED",
  INVALID_VALUE: "INVALID_VALUE",
  INVALID_NAME: "INVALID_NAME",
  INVALID_EMAIL: "INVALID_EMAIL",
  INVALID_PHONE: "INVALID_PHONE",
  INVALID_DATE: "INVALID_DATE",
  INVALID_NUMBER: "INVALID_NUMBER",
  INVALID_ADDRESS: "INVALID_ADDRESS",
  INVALID_CITY_NAME: "INVALID_CITY_NAME",
  INVALID_CONTRACT_NUMBER: "INVALID_CONTRACT_NUMBER",
  INVALID_SOCIAL_SECURITY_NUMBER: "INVALID_SOCIAL_SECURITY_NUMBER",
  INVALID_SOCIAL_SECURITY_LENGTH: "INVALID_SOCIAL_SECURITY_LENGTH",
  INVALID_SOCIAL_SECURITY_KEY: "INVALID_SOCIAL_SECURITY_KEY",
  INVALID_DEPARTMENT_CODE: "INVALID_DEPARTMENT_CODE",
  AGE_18: "AGE_18",
  AGE_12: "AGE_12",
  AGE_25: "AGE_25",
  AGE_84: "AGE_84",
  AGE_12_84: "AGE_12_84",
  MIN_TODAY: "MIN_TODAY",
  IBAN_MODE97_FAILED: "IBAN.MODE97_FAILED",
  IBAN_TOO_SHORT: "IBAN.TOO_SHORT",
  IBAN_BAD_COUNTRY_CODE: "IBAN.BAD_COUNTRY_CODE",
  IBAN_BAD_CHARSET: "IBAN.BAD_CHARSET",
  IBAN_UNSUPPORTED_COUNTRY: "IBAN.UNSUPPORTED_COUNTRY",
  IBAN_BAD_LENGTH: "IBAN.BAD_LENGTH",
  BIC_BAD_LENGTH: "BIC.BAD_LENGTH",
  BIC_BAD_CHARSET: "BIC.BAD_CHARSET",
  BIC_BAD_BANK_CODE: "BIC.BAD_BANK_CODE",
  BIC_BAD_COUNTRY_CODE: "BIC.BAD_COUNTRY_CODE",
  BIC_BAD_LOCATION: "BIC.BAD_LOCATION",
  BIC_BAD_BRANCH: "BIC.BAD_BRANCH",
};

export const FIELD_INPUT_TYPES = {
  TEXT: "text",
  DATE: "date",
  NUMBER: "number",
  SLIDER: "slider",
  EMAIL: "email",
  PHONE: "phone",
};

export const DATE_INPUT_CONFIG = {
  PICKER: "date",
  FORMAT: "DD/MM/YYYY",
};

export const DATE_BOUND_MODES = {
  DATE: "date",
  DURATION: "duration",
};

export const DATE_BOUND_UNIT = {
  DAY: "day",
  MONTH: "month",
  YEAR: "year",
};

export const RELATIVE_TODAY = "today";

export const FIELD_VALIDATION_LIMITS = {
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
  ADDRESS_MIN_LENGTH: 4,
  OPTIONAL_TEXT_MAX_LENGTH: 255,
  ADULT_MIN_AGE: 18,
  BIRTH_DATE_MIN_YEARS: 100,
  ISSUANCE_DATE_MIN_MONTHS: 1,
  ISSUANCE_DATE_MAX_YEARS: 1,
  POSITIVE_NUMBER_MIN: 0,
  POSITIVE_NUMBER_STEP: 1,
  NUMBER_MAX_PLACEHOLDER: 100,
  EMAIL_MAX_LENGTH: 254,
  NIR_LENGTH: 15,
  BIC_LENGTH_SHORT: 8,
  BIC_LENGTH_LONG: 11,
};

export const FIELD_VALIDATION_PATTERNS = {
  SIRET: "^\\d{14}$",
  SIREN: "^\\d{9}$",
};
